import React, { Component } from "react";
import Hero from './../../alpineComponents/hero';
import CenteredParagraph from './../../alpineComponents/centeredParagraph';
import CheckmarkRow from './../../alpineComponents/checkmarkRow';
import  './../../utils/analytics';
import ContactInfo from './../../components/contactInfo';
import ContactForm from './../../components/contactForm';

export default class extends Component {

  render() {
    return (
		<div className="light-grey-background">
      <div className="large-padding primary-background">
        <div className="small-max-width-container small">
          <h1 className="white">{'Contact Us'}</h1>
          <ContactForm
            name={true}
            email={true}
            phone={true}
            type={true}
            location={true}
            message={true}
            buttonText={'Submit'}
            subject={'Pilates Avenue Contact Form'}
          />
        </div>
      </div>
      <div className="section-padding max-width-container">
        <ContactInfo />
      </div>
      <div className="section-padding max-width-container">
        {/*
        <div class='embed-container'><div class='mapouter'><div class='gmap_canvas'><iframe width='1080' height='434' id='gmap_canvas' src='https://maps.google.com/maps?q=501%20N%20Santa%20Cruz%20Ave.,%20Suite%20D,%20Los%20Gatos,%20CA%2095030%20&t=&z=17&ie=UTF8&iwloc=&output=embed' frameborder='0' scrolling='no' marginheight='0' marginwidth='0'></iframe></div></div></div>
        */}
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact/index.js